export const RELEASE_COMPLIANCE_STATUS_OPTIONS = {
  COMPLAINT: {
    label: 'Compliant',
    color: '#389e0d',
  },
  NOT_COMPLAINT: {
    label: 'Not Compliant',
    color: '#F5222D',
  },
  PENDING: {
    label: 'Pending',
    color: '#686363',
  },
};

export const COMPLIANCE_STATUS_TITLE = 'Compliance Status';

export const NON_COMPLIANCE_REASONS_TITLE = 'Non-Compliant Reasons';

export const JIRA_COMPLETED_STATUSES = {
  story: ['done', 'cancelled', 'qa complete', 'ready for prod'],
  'sub-task': [
    'done',
    'cancelled',
    'qa complete',
    'ready for prod',
    'closed',
    'resolved',
  ],
  task: [
    'done',
    'cancelled',
    'qa complete',
    'ready for prod',
    'closed',
    'resolved',
  ],
  bug: ['closed', 'qa complete', 'ready for prod'],
  epic: ['done'],
};

export const AG_GRID_FILTER_BLANK_VALUE_TITLE = '(Blank)';
